import { Command, ICommandResult } from '@/_core/cqrs/types/commands';

export interface CloneExampleStorymapToWorkspaceResult extends ICommandResult {
    Url: string;
}

export class CloneExampleStorymapToWorkspace extends Command<CloneExampleStorymapToWorkspaceResult> {
    constructor(public ExampleSlug: string, public WorkspaceId: number, public ProductId: string) {
        super('CloneExampleStorymapToWorkspace');
    }
}
